import { useEffect, useMemo, useState } from 'react';
import { KeywordTableState } from '../../components/muiLegacy/Tables/KeywordTable/logic/useKeywordTableState';
import deepEqual from 'deep-equal';

export function useCalculateNow(keywordTableState: KeywordTableState) {
  // Final keywordTableState
  const [dashboardLoading, setDashboardLoading] = useState(false);
  const [finalFilterState, setFinalFilterState] = useState({
    filterState: keywordTableState.filterState,
    backendFilterState: keywordTableState.backendFilterState,
  });
  const handleCalculateNow = () =>
    setFinalFilterState({
      filterState: keywordTableState.filterState,
      backendFilterState: keywordTableState.backendFilterState,
    });

  const notCalculated = useMemo(() => {
    const result = !deepEqual(keywordTableState.filterState, finalFilterState.filterState);
    return result;
  }, [keywordTableState.filterState, finalFilterState.filterState]);

  useEffect(() => {
    if (
      keywordTableState.filterState.progressRequestIds !==
      finalFilterState.filterState.progressRequestIds
    ) {
      setFinalFilterState({
        filterState: keywordTableState.filterState,
        backendFilterState: keywordTableState.backendFilterState,
      });
    }
  }, [keywordTableState.filterState, finalFilterState.filterState]);

  const finalKeywordTableState = useMemo(
    (): KeywordTableState => ({
      ...keywordTableState,
      filterState: finalFilterState.filterState,
      backendFilterState: finalFilterState.backendFilterState,
    }),
    [keywordTableState, finalFilterState]
  );

  return {
    finalKeywordTableState,
    notCalculated,
    handleCalculateNow,
    setDashboardLoading,
    dashboardLoading,
  };
}
